import { RootState } from '@reducers';

export const selectCarQuotePaymentPage = (state: RootState) => state.CarQuotePaymentPageReducer;
